import React from "react";
import styles from "./productDetailsPage.module.scss";
import ProductDetails from "../../components/uiComponents/productDetails/ProductDetails";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { NavLink, useNavigate } from "react-router-dom";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";

const ProductDetailsPage = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="Product Details" // or any icon/component
      />
      <div className={styles.btnContainer}>
        <OutlinedButton
          title={"Edit"}
          txtClr={"#1976D2"}
          border={"1px solid#1976D2"}
          width={"90px"}
          startIcon={<EditOutlinedIcon />}
          height={"34px"}
          borderRadius={"8px"}
          onclick={() =>
            navigate("/products/addproductDetails", { state: "edit" })
          }
        />
      </div>
      <ProductDetails />
    </div>
  );
};

export default ProductDetailsPage;
